import { render, staticRenderFns } from "./reset-password.html?vue&type=template&id=05ba3436&scoped=true&external"
import script from "./reset-password.js?vue&type=script&lang=js&external"
export * from "./reset-password.js?vue&type=script&lang=js&external"
import style0 from "./reset-password.scss?vue&type=style&index=0&id=05ba3436&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba3436",
  null
  
)

export default component.exports